<template>
	<div v-if="bigImg" id="clubClass_dialog_swiper">
		<div class="shadow_bg">
			<div class="open_img" :style="{ top: top + 'px' }">
				<div class="close_btn" @click="close_window"><img src="../../assets/img/close_icon.png"></div>
				<Swiper class="swiper" :options="swiperOption" ref="chartSwiper1">
					<Swiper-slide class="bigslide" v-for="(photo, index) in photoList" :key="index">
						<img :class="`img${index}`" :src="cosPath + photo.photoPath" :dataInfo="photo.courseName"
							@load="onImgLoad" @click="hideImg">
						<p class="open_imgtext"> {{ photo.courseName }} </p>
					</Swiper-slide>
				</Swiper>
				<!-- 下一页 -->
				<div class="swiper-button-next"></div>
				<!-- 上一页 -->
				<div class="swiper-button-prev"></div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	mounted() {
		this.top = (document.body.clientHeight - 800) / 2;
		var _this = this;
		window.onresize = function () { // 定义窗口大小变更通知事件
			_this.top = (document.documentElement.clientHeight - 800) / 2;
			console.log(_this.top);
		}
	},
	watch: {
		'top': function () { //监听屏幕高度变化
			this.top = (document.body.clientHeight - 800) / 2;
		}
	},
	data() {
		var _this = this;
		return {
			realIndex: 0,
			top: 0,
			bigImg: "",
			imgHeight: 0,
			imgWidth: 0,
			imgLeft: 0,
			animatecc: "",
			photoList: [],
			cosPath: '',
			swiperOption: {
				loop: true, // 无限循环
				observer: false, //修改swiper自己或子元素时，自动初始化swiper
				observeParents: false, //修改swiper的父元素时，自动初始化swiper
				slidesPerView: "auto", // 设置可视区一共显示几张图片,设置auto,设置auto为自适应;
				centeredSlides: true, // 设置为true时,带有active-slide类名的图片会居中
				loopAdditionalSlides: 0, //loop模式下会在slides前后复制若干个slide,，前后复制的个数不会大于原总个数。默认为0，前后各复制1个。0,1,2 --> 2,0,1,2,0
				//  页码
				pagination: {
					el: '.swiper-pagination',
					type: 'bullets',
					dynamicMainBullets: 2, //动态分页器的主指示点的数ss量
					clickable: true, //此参数设置为true时，点击分页器的指示点分页器会控制Swiper切换。
				},
				//  点击上一页 下一页
				navigation: {
					nextEl: '.swiper-button-next', //前进按钮的css选择器或HTML元素。
					prevEl: '.swiper-button-prev', //后退按钮的css选择器或HTML元素。
					hideOnClick: true, //点击slide时显示/隐藏按钮
					disabledClass: 'my-button-disabled', //前进后退按钮不可用时的类名。
					hiddenClass: 'my-button-hidden', //按钮隐藏时的Class
				},
				on: {
					slideChangeTransitionEnd: function () {
					},
					toEdge: function () {
						console.log(this);
					},
					init: function () {
						this.slideTo(_this.realIndex, 0, false);
					}
				},
			}
		}
	},
	methods: {
		onImgLoad(e) {
			const clazzName = e.target.className;
			const list = document.getElementsByClassName(clazzName);
			// 当图片加载完成后，获取图片的原始宽度和高度，并根据宽度计算出高度
			for (var i = 0; i < list.length; i++) {
				const img_w = list[i].naturalWidth;
				const img_h = list[i].naturalHeight;
				const w = 1400;
				const h = 800;
				if (img_w / w <= img_h / h) {
					var width = (h * img_w) / img_h; //高度等比缩放 
					list[i].nextElementSibling.width = width; // 高度 = 原始高度 / 原始宽度 * 100
					list[i].width = width;
					list[i].height = h;
					//this.imgHeight = h; // 高度 = 原始高度 / 原始宽度 * 100
				} else {
					var height = (w * img_h) / img_w; //宽度等比缩放 
					list[i].nextElementSibling.width = w;
					list[i].width = w; // 高度 = 原始高度 / 原始宽度 * 100
					list[i].height = height; // 高度 = 原始高度 / 原始宽度 * 100
				}
				if (w - list[i].width > 0) {
					list[i].style.marginLeft = (w - list[i].width) / 2 + "px";
				}
				if (h - list[i].height > 0) {
					list[i].style.marginTop = (h - list[i].height) / 2 + "px";
				}
			}
			this.animatecc = "go-transition-quick animate__animated animate__rotateInUpLeft";
		},
		hideImg() {
			this.bigImg = "";
			this.animatecc = "";
		},
		close_window() {
			this.$emit("closeImg");
		},
		init(cosPath, currentUrl, photoList, index) {
			console.log("进入弹框调用函数");
			let _this = this;
			_this.bigImg = currentUrl;
			_this.realIndex = index;
			_this.cosPath = cosPath;
			_this.photoList = JSON.parse(photoList);
		}
	}
}
</script>
<style lang="scss">
#clubClass_dialog_swiper {

	.shadow_bg {
		width: 100%;
		height: 100%;
		position: fixed;
		background: rgba(0, 0, 0, 0.6);
		padding: 0 !important;
		top: 0;
		left: 0;
		z-index: 999
	}

	.open_img {
		width: 1400px;
		height: 800px;
		position: fixed;
		top: 100px;
		left: 50%;
		margin-Left: -700px;
		z-index: 9999;
		background-image: linear-gradient(135deg, #16304d, #060816);
		border-radius: 0.15rem;
		border: 1px solid #004774;
		box-shadow: 0 0 0.2rem #0075be;
		overflow: hidden;
	}

	.close_btn {
		position: absolute;
		width: 0.4rem;
		right: 0.15rem;
		top: 0.15rem;
		z-index: 99
	}

	.close_btn img {
		width: 100%;
	}

	.close_btn:hover {
		cursor: pointer;
	}

	.shadow_bg .open_img .swiper {
		padding: 0 !important
	}

	.swiper .bigslide {
		width: 100%;
	}

	.swiper .bigslide img {
		display: block;
		object-fit: cover
	}

	.open_imgtext {
		color: #fff;
		padding: 15px 20px;
		font-size: 0.3rem;
		border-top: 1px solid #029aff;
		border-top-left-radius: 0.15rem !important;
		border-top-right-radius: 0.15rem !important;
		background: rgba(0, 0, 0, .4);
		position: absolute;
		top: 0px;
		left: 0;
		right: 0;
	}
}
</style>